import React, { useState } from 'react';
import { Accordion } from 'react-bootstrap';
import PrecedentiEsamiForm from './PrecedentiEsamiForm';

const PrecedentiEsamiList = ({ precedentiEsami, onUpdate, onRemove }) => {
    const [editIndex, setEditIndex] = useState(null);

    const handleEdit = (index) => {
        setEditIndex(index);
    };

    const handleCancelEdit = () => {
        setEditIndex(null);
    };

    const handleSubmitEdit = (index, updatedEsame) => {
        onUpdate(index, updatedEsame);
        setEditIndex(null);
    };

    return (
        <Accordion>
            {precedentiEsami.map((esame, index) => (
                <Accordion.Item eventKey={String(index)} key={index}>
                    <Accordion.Header>
                        <b>{index + 1}) Esame: {esame.nomeEsame.toUpperCase()}</b>
                    </Accordion.Header>
                    <Accordion.Body>
                        {editIndex === index ? (
                            <PrecedentiEsamiForm
                                initialData={esame}
                                onSubmit={(updated) => handleSubmitEdit(index, updated)}
                                onCancel={handleCancelEdit}
                            />
                        ) : (
                            <>
                                <div className="d-flex justify-content-between mt-3">
                                    <button
                                        className="btn btn-warning text-white"
                                        onClick={() => handleEdit(index)}
                                    >
                                        Modifica
                                    </button>
                                    <button
                                        className="btn btn-danger text-white"
                                        onClick={() => onRemove(index)}
                                    >
                                        Cancella
                                    </button>
                                </div>
                            </>
                        )}
                    </Accordion.Body>
                </Accordion.Item>
            ))}
        </Accordion>
    );
};

export default PrecedentiEsamiList;
